import { render, staticRenderFns } from "./DetalheCertificado.vue?vue&type=template&id=538b4cf8&scoped=true"
import script from "./DetalheCertificado.vue?vue&type=script&lang=js"
export * from "./DetalheCertificado.vue?vue&type=script&lang=js"
import style0 from "./DetalheCertificado.vue?vue&type=style&index=0&id=538b4cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b4cf8",
  null
  
)

export default component.exports